var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertDistance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  "data-name": "Alert Distance"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Path 324"
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.888 0 9.113 24.631L28.013 42 2.656 32.184l-2.654-21.5 21.415 6.831Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "m31.888 8.825-8.79 13.419-18.363-5.85 1.596 12.924 20.4 7.896 10.73-13.324zm1-8.825L42 24.63 28.013 42 2.654 32.184 0 10.687l21.417 6.823z"
}))));
export default SvgAlertDistance;